export const CONTACT = {
  whatsappNumber: "919996389930",
  whatsappDisplay: "+91 99963 89930",
  email: "yogendra.agarwal@theinfraedge.com",
  facebook: "https://www.facebook.com/share/1FbL1cdXZN/",
  instagram: "https://www.instagram.com/infraedge",
};

export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_23506279-cf46-4245-b562-3aaff2e009f1/artifacts/fkvjt0ee_ChatGPT%20Image%20Jul%2020%2C%202026%2C%2009_27_04%20PM.png";

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(n || 0));

export const SKYLINE_BG =
  "https://images.unsplash.com/photo-1759383984112-0aa685194087?q=85&w=2000&auto=format&fit=crop";
